import { POST } from "../../index";

export const getCarFault = (param) => POST("/v1/caution/getCarFault", param);
export const getDriverViolation = (param) => POST("/v1/caution/getDriverViolation", param);
export const insertRequestRepair = (param) => POST("/v1/caution/insertRequestRepair", param);
export const pushViolation = (param) => POST("/v1/caution/pushViolation", param);
export const updateHandleState = (param) => POST("/v1/caution/updateHandleState", param);
export const selectFaultType = (param) => POST("/v1/caution/selectFaultType", param);
export const selectViolationType = (param) => POST("/v1/caution/selectViolationType", param);
export const getUserProfile = (param) => POST("/v1/caution/getUserProfile", param);
export const updateUserProfile = (param) => POST("/v1/caution/updateUserProfile", param);
export const switchLanguage = (param) => POST("/v1/user/switchLanguage", param);
